import { ACCENT } from './landingData';

const SILK = "'Silkscreen', monospace";
const VT = "'VT323', monospace";

const PANEL: React.CSSProperties = {
  height: 158, display: 'flex', flexDirection: 'column',
  border: '1px solid #1a281f', background: '#070c09', overflow: 'hidden',
};
const HEAD: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
  fontFamily: SILK, fontSize: 7, letterSpacing: 0.5,
  borderBottom: '1px solid #16241c', padding: '6px 9px', flexShrink: 0,
};
const BODY: React.CSSProperties = { padding: '9px 10px', fontFamily: VT, fontSize: 15, lineHeight: 1.28, flex: 1, minHeight: 0 };
const RULE: React.CSSProperties = { borderTop: '1px dashed #1e2f24', margin: '7px 0' };

function Row({ mark, markColor, label, value }: { mark: string; markColor: string; label: string; value?: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 7 }}>
      <span style={{ color: markColor, flexShrink: 0 }}>{mark}</span>
      <span style={{ color: '#9fb0a4', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
      {value && <span style={{ color: ACCENT, flexShrink: 0 }}>{value}</span>}
    </div>
  );
}

/**
 * The three step screens.
 *
 * These replaced abstract CSS shapes — a gradient, two rectangles and a
 * glowing square — that decorated the section without explaining anything.
 * Every string below is real: quest titles and owner agents from quests.ts,
 * a deliverable path from the same file, and the Era 2 criteria verbatim from
 * server/stressTests/era2.ts. If the gate's bar moves, this picture is wrong,
 * which is the point — a landing page that invents its own screenshots is
 * how a product ends up advertising something it does not do.
 */
export default function StepScreen({ step }: { step: '01' | '02' | '03' }) {
  if (step === '01') {
    return (
      <div style={PANEL}>
        <div style={{ ...HEAD, color: '#6e8fb5' }}><span>OVERSEER&rsquo;S OFFICE</span><span style={{ color: '#3f5a4a' }}>ROUTING</span></div>
        <div style={BODY}>
          <div style={{ color: '#c2d2c6' }}>
            <span style={{ color: ACCENT }}>&gt; </span>a tool for solo founders
            <span style={{ animation: 'blink 1.1s step-end infinite' }}>_</span>
          </div>
          <div style={RULE} />
          <Row mark="◫" markColor="#4ecb77" label="Map the wasteland" value="SCOUT" />
          <Row mark="◫" markColor="#b07cc6" label="Prep interview script" value="INVES." />
          <Row mark="◫" markColor="#ff9c52" label="Build the MVP" value="TINK." />
        </div>
      </div>
    );
  }

  if (step === '02') {
    return (
      <div style={PANEL}>
        <div style={{ ...HEAD, color: '#7fae72' }}><span>ARTIFACTS</span><span style={{ color: ACCENT }}>WRITTEN ✓</span></div>
        <div style={BODY}>
          <div style={{ color: '#b6e5a5', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>▸ scout/competitors.md</div>
          <div style={RULE} />
          <div style={{ color: '#8fa196' }}>## White space</div>
          <div style={{ color: '#9fb0a4' }}>Direct rivals: 6 · Adjacent: 11</div>
          <div style={{ color: '#6d7f73' }}>Nobody serves founders with</div>
          <div style={{ color: '#6d7f73' }}>no research budget.</div>
        </div>
      </div>
    );
  }

  return (
    <div style={PANEL}>
      <div style={{ ...HEAD, color: '#d98080' }}><span>QC LAB</span><span style={{ color: '#3f5a4a' }}>ERA 2 GATE</span></div>
      <div style={BODY}>
        <Row mark="✓" markColor={ACCENT} label="≥20 interview notes filed" value="20/20" />
        <Row mark="✓" markColor={ACCENT} label="≥60% confirm pain" value="68%" />
        <Row mark="✓" markColor={ACCENT} label="Opportunity memo signed" />
        <div style={RULE} />
        <div style={{ display: 'inline-block', fontFamily: SILK, fontSize: 9, letterSpacing: 1, color: '#06110a', background: ACCENT, padding: '5px 8px', boxShadow: '0 0 20px -3px rgba(134,212,111,0.9)' }}>
          VERDICT: GREENLIGHT
        </div>
      </div>
    </div>
  );
}
